import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchStripeTokenMutation,
  Flex_FetchStripeTokenMutationVariables,
} from '~/typings/graphql';
import { errors } from '~/utils/error-messages';
import { FETCH_STRIPE_TOKEN } from './fetch-stripe-token.queries';

export const fetchStripeToken = async (
  params: FetchStripeTokenParams,
): Promise<FetchStripeTokenResponse> => {
  try {
    const { data } = await apolloClient.mutate<
      Flex_FetchStripeTokenMutation,
      Flex_FetchStripeTokenMutationVariables
    >({
      mutation: FETCH_STRIPE_TOKEN,
      variables: {
        accountId: params.accountId,
        achMicrodepositVerification: params.allowMicroDeposits,
      },
    });

    const stripeToken = data?.createSetupIntent.stripeClientSecret;
    if (!stripeToken) throw new Error(errors.missingFetchStripeToken);
    return { stripeToken };
  } catch (e) {
    throw new Error(errors.missingFetchStripeToken);
  }
};

export type FetchStripeTokenParams = {
  accountId: number;
  allowMicroDeposits: boolean;
};

export interface FetchStripeTokenResponse {
  stripeToken: string;
}
